import { toFixedDecimalString } from '../../shared/chart-options';
import { formatPlayer } from '../../lib/format';

export function LineupBarChartTooltip({ data: { teamShift, teamColor } }) {
  const players = Players(teamShift.lineup.players);
  const shiftStats = teamShift.stats.shift;

  return `
    <div class="chart-tooltip chart-tooltip--center">
      <table>
        <thead>
          <tr><th colSpan="4" style="color: ${teamColor}" class="cell-center">${players}</th></tr>
          <tr><th colSpan="4" class="cell-center">Played time: ${
            shiftStats.time
          }</th></tr>
          <tr>
            <th></th>
            <th class="cell-right">Team</th>
            <th></th>
            <th class="cell-right">Opponent</th>
          </tr>
        </thead>

        <tbody>

          <tr>
            <th>Points Scored:</th>
            <td class="cell-right active">${shiftStats.home.points}</td>
            <td>(${shiftStats.home.plusMinus})</td>
            <td class="cell-right active">${shiftStats.visitor.points}</td>
          </tr>

          <tr>
            <th>Points per Minute:</th>
            <td class="cell-right active">
            ${toFixedDecimalString(shiftStats.home.pointsPerMinute)}
            </td>
            <td></td>
            <td class="cell-right active">
              ${toFixedDecimalString(shiftStats.visitor.pointsPerMinute)}
            </td>
          </tr>

          <tr>
            <th>Points per Possession:</th>
            <td class="cell-right active">
            ${toFixedDecimalString(shiftStats.home.pointsPerPossession)}
            </td>
            <td></td>
            <td class="cell-right active">
            ${toFixedDecimalString(shiftStats.visitor.pointsPerPossession)}
            </td>
          </tr>
          
        </tbody>

      </table>
    </div>
  `;
}

function Players(players) {
  return players
    .map(formatPlayer)
    .map(player => `<span class="nowrap">${player}</span>`)
    .join(' - ');
}
